/**
 * Pflegetexte kommen aus dem Backend und enthalten häufig Überschriften ohne
 * Leerzeichen nach den Rautezeichen („##Für wen er gemacht ist"). Nach der
 * Markdown-Spezifikation ist das keine Überschrift, deshalb erschien die Zeile
 * bisher als Rohtext. Wir reparieren das ausschließlich für die Anzeige –
 * gespeicherte Inhalte bleiben unverändert.
 */
export function normalizeMarkdown(input: string | null | undefined): string {
  if (!input) return "";
  return input
    .replace(/^(\s{0,3}#{1,6})(?=[^#\s])/gm, "$1 ")
    .replace(/^(\s{0,3}>)(?=[^>\s])/gm, "$1 ");

}
